import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation UpdateDepartment($id: ID!, $model: DepartmentInput!) {
  updateDepartment(id: $id, department: $model){
    id
    name
    emails
    teams {
      id
      name
    }
    allTeamsOn
  }
}`;

function updateDepartment(id, model) {
  return apollo.client.mutate({
    mutation,
    variables: {
      id,
      model,
    },
  }).then((res) => res.data.updateDepartment);
}

export default updateDepartment;
